import { isLocalDevHost } from "./dev-mode";

const debugEnabled =
  typeof import.meta !== "undefined" &&
  (import.meta.env as Record<string, string | undefined>).VITE_DEBUG_LOGS === "true";

function shouldLog(): boolean {
  if (typeof window === "undefined") return false;
  return isLocalDevHost() || debugEnabled;
}

/** Structured debug logging for access/playback flows (localhost or VITE_DEBUG_LOGS). */
export function debugLog(
  scope: string,
  message: string,
  data?: Record<string, unknown>,
): void {
  if (!shouldLog()) return;
  if (data !== undefined) {
    console.info(`[${scope}] ${message}`, data);
  } else {
    console.info(`[${scope}] ${message}`);
  }
}

/** Refreshes Firebase Auth custom claims on the client after server-side updates. */
export async function refreshAuthTokenClaims(): Promise<{
  ok: boolean;
  subscriptions?: unknown;
  videos?: unknown;
  error?: string;
}> {
  const { callRefreshTokenServer } = await import("./firebase/functions");
  const { getFirebaseAuth } = await import("./firebase/config");

  const refresh = await callRefreshTokenServer();
  if ("error" in refresh) {
    return { ok: false, error: refresh.error };
  }

  const user = getFirebaseAuth().currentUser;
  if (!user) {
    return { ok: false, error: "Not signed in." };
  }

  const token = await user.getIdTokenResult(true);
  return {
    ok: true,
    subscriptions: token.claims.subscriptions,
    videos: token.claims.videos,
  };
}
